import React from 'react'
import { useState } from 'react';
import './formCatDepenses.scss'
import axios from 'axios';
import config from '../../../config';
import { toast } from 'react-toastify';

const FormCatDepense = ({ fetchData, closeModal }) => {
  const DOMAIN = config.REACT_APP_SERVER_DOMAIN;
  const [data, setData] = useState({})


  const handleInputChange = async (e) => {
    const fieldName = e.target.name;
    let fieldValue = e.target.value;

    fieldValue = fieldValue.charAt(0).toUpperCase() + fieldValue.slice(1);
  
    setData((prev) => ({ ...prev, [fieldName]: fieldValue }));
  };


  const handleClick = async (e) => {
    e.preventDefault();

    try{
      await axios.post(`${DOMAIN}/api/depenses/catDepenses`, data)
      toast.success('La categorie de dépenses a été enregistrée avec succès.');
      if (typeof fetchData === 'function') fetchData();   // refetch au lieu de recharger la page
      if (typeof closeModal === 'function') closeModal();

    }catch(err) {
      toast.error(err?.response?.data?.message || err?.message || "Enregistrement impossible.");
    }
  }
  

  return (
    <>
        <div className="formCatDepense">
          <div className="product-container">
            <div className="product-wrapper">
                <div className="form-controle-desc">
                  <label htmlFor="">Nom de la dépense</label>
                  <input type="text" name='nom' style={{padding:'8px 10px', border:'1px solid #c5c5c5', outline:'none', borderRadius:'5px'}} placeholder='Entrer le nom...' onChange={handleInputChange} />
                </div>
              <div className="form-controle-desc">
                <label htmlFor="">Description</label>
                <textarea name="description"  placeholder='Description.....' onChange={handleInputChange}></textarea>
              </div>
              <div className="form-submit">
                <button className="btn-submit" onClick={handleClick}>Envoyer</button>
                <button className="btn-submit btn-annuler" onClick={(e)=> { e.preventDefault(); if (typeof closeModal === 'function') closeModal(); }}>Annuler</button>
              </div>
            </div>
          </div>
        </div>

    </>
  )
}

export default FormCatDepense